export enum PinnedItemType {
  ResponseOption,
  MatrixRow
}
